export default __webpack_public_path__ + "static/14-4d648a45907fe39e2aeb98ff28da7b68.webp";